export default __webpack_public_path__ + "static/media/try1.f47ed738.PNG";